/**
 * @desc 侧边栏任务卡片组件
 * 支持同时展示新手引导卡片（常驻）和任务卡片
 */

import { useEffect, useState, useCallback } from 'react';
import { TipCard } from '@tencent/tpm-trtc-console';
import { ArrowRightIcon } from '@tencent/tpm-audio-video-react-icons';
import { eventBus } from '@src/utils/tools/eventBus';

interface TaskCardData {
  title: string;
  description?: string;
  buttonText: string;
  buttonStatus: string;
}

export const MenuTaskCard = () => {
  const [cardData, setCardData] = useState<TaskCardData | null>(null);
  const [guideCardData, setGuideCardData] = useState<TaskCardData | null>(null);
  const [isCollapse, setIsCollapse] = useState(false);

  // 监听任务卡片更新
  useEffect(() => {
    return eventBus.on('taskCardUpdate', (data: TaskCardData) => {
      setCardData(data);
    });
  }, []);

  // 监听新手引导卡片更新
  useEffect(() => {
    return eventBus.on('onboardingGuideCardUpdate', (data: TaskCardData) => {
      setGuideCardData(data);
    });
  }, []);

  // 挂载完成后发起握手，通知子应用重新派发卡片数据
  // 解决「子应用先派发、本组件后挂载导致首次事件丢失」的时序竞态问题
  useEffect(() => {
    eventBus.dispatch('taskCardReady');
  }, []);

  const handleButtonClick = useCallback((buttonStatus: string) => {
    eventBus.dispatch('taskCardButtonClick', {
      buttonStatus,
    });
  }, []);

  const handleCollapseClick = useCallback(() => {
    setIsCollapse(prev => !prev);
  }, []);

  if (!cardData && !guideCardData) return null;

  const renderCardButton = (data: TaskCardData, iconColor: string = '#E0794C') => (
    <a
      onClick={() => handleButtonClick(data.buttonStatus)}
      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
    >
      {data.buttonText}
      <ArrowRightIcon size={16} color={iconColor} />
    </a>
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: 'calc(100% - 12px)',
      }}
    >
      {guideCardData && (
        <TipCard
          style={{ width: '100%' }}
          version="v2"
          theme="primary"
          isCollapse={isCollapse}
          title={guideCardData.title}
          description={guideCardData.description}
          showIcon
          button={renderCardButton(guideCardData, '#006af6')}
          onCollapseClick={handleCollapseClick}
        />
      )}
      {cardData && (
        <TipCard
          style={{ width: '100%' }}
          version="v2"
          isCollapse={isCollapse}
          title={cardData.title}
          description={cardData.description}
          showIcon
          button={renderCardButton(cardData)}
          onCollapseClick={handleCollapseClick}
        />
      )}
    </div>
  );
};
